export { default } from './ModuleTitle';
